import React, { useMemo } from "react";
import { useFormContext, Controller } from "react-hook-form";
import FormSimple from "@components/formGroup/formSimple";
import { REGEX_EMAIL, REGEX_PHONE, REGEX_PHONE_INVERSE } from "@helpers/_constants";
import { useTranslation } from "react-i18next";
import { useUserPermission } from "@hooks/users";

function SharedEmergency(props) {
  const { control } = useFormContext();
  const { fieldNamePrefix = "", readOnly, isEnterprisePage } = props;
  const { t: mainTranslator } = useTranslation("pages.employés.infoPers");
  const { canAccessFirstContact, canAccessSecondContact } = useUserPermission();

  const isReadOnly = useMemo(() => {
    if (fieldNamePrefix === "firstEmergencyContact") {
      return isEnterprisePage ? readOnly : (readOnly && !canAccessFirstContact);
    }
    if (fieldNamePrefix === "secondEmergencyContact") {
      return isEnterprisePage ? readOnly : (readOnly && !canAccessSecondContact);
    }
    return true;
  }, [fieldNamePrefix, canAccessFirstContact, canAccessSecondContact, readOnly, isEnterprisePage]);

  const fieldContainerClass = "arh-min-w-0";
  const labelClass = "arh-flex arh-min-h-[2rem] arh-items-end";

  return (
    <div className="arh-grid arh-w-full arh-grid-cols-4 arh-gap-x-[1.875rem] arh-pb-[2rem] arh-pl-[5.8rem] arh-pr-[2.875rem] tablet-960:arh-grid-cols-2 tablet-960:arh-gap-x-5 tablet-960:!arh-pl-[2.5rem] tablet-960:!arh-pr-[1rem] mobile-500:arh-grid-cols-1">
      <div className={fieldContainerClass}>
        <Controller
          control={control}
          name={`${fieldNamePrefix}.contactName`}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <FormSimple
              label={mainTranslator("Nom Contact")}
              placeholder={mainTranslator("Nom Contact")}
              ParentForm="arh-mb-[1.75rem]"
              classLabel={labelClass}
              type="text"
              onChange={onChange}
              value={value}
              readOnly={isReadOnly}
            />
          )}
        />
      </div>
      <div className={fieldContainerClass}>
        <Controller
          control={control}
          name={`${fieldNamePrefix}.employeeRelationship`}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <FormSimple
              label={mainTranslator("Relation avec l’employé")}
              placeholder={mainTranslator("Relation avec l’employé")}
              ParentForm="arh-mb-[1.75rem]"
              classLabel={labelClass}
              type="text"
              onChange={onChange}
              value={value}
              readOnly={isReadOnly}
            />
          )}
        />
      </div>
      <div className={fieldContainerClass}>
        <Controller
          control={control}
          name={`${fieldNamePrefix}.contactPhone`}
          rules={{ pattern: REGEX_PHONE }}
          defaultValue=""
          render={({ field: { onChange, value }, fieldState: { invalid } }) => (
            <FormSimple
              label={mainTranslator("Téléphone du contact")}
              placeholder={mainTranslator("Téléphone du contact")}
              ParentForm="arh-mb-[1.75rem]"
              classLabel={labelClass}
              type="text"
              onChange={(e) => {
                const cleanedValue = e.target.value.replace(REGEX_PHONE_INVERSE, "");
                onChange(cleanedValue);
              }}
              value={value}
              invalid={invalid}
              readOnly={isReadOnly}
            />
          )}
        />
      </div>
      <div className={fieldContainerClass}>
        <Controller
          control={control}
          name={`${fieldNamePrefix}.contactEmail`}
          rules={{ pattern: REGEX_EMAIL }}
          defaultValue=""
          render={({ field: { onChange, value }, fieldState: { invalid } }) => (
            <FormSimple
              label={mainTranslator("Courriel du contact")}
              placeholder={mainTranslator("Courriel du contact")}
              ParentForm="arh-mb-[1.75rem]"
              classLabel={labelClass}
              type="email"
              onChange={(e) => onChange(e.target.value.toLowerCase())}
              value={value}
              invalid={invalid}
              readOnly={isReadOnly}
            />
          )}
        />
      </div>
    </div>
  );
}

export default SharedEmergency;
